import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/tms-vs-spravato")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "saint-vs-spravato" },
    });
  },
});
